<script lang="typescript">
    import { createEventDispatcher } from "svelte";
    import { LookupDialog } from "./dialogs";
    import CaretDown from "./icons/caret-down.svelte";
    import { ModalSystem } from "./systems";
    export let id = "input";
    export let items: any[] = [];
    export let icon:any;
    export let selected: any;
    export let value: any;
    export let name: string = "name";
    export let disabled = false;
    export let dictionary: DropdownDictionary;
    export let dictionaryFunc: (item: any) => DropdownDictionary;

    interface DropdownDictionary {
        value: string;
        title: string;
        description: String;
        icon?:string;
    }

    let iitems = items;
    let ivalue = value;
    let iTitle = "";
    $: {
        iitems = items;
        ivalue = value;

        display();
    }

    export let label = "Input Label";
    export let bg = "var(--color-level-1)";
    export let width = "100%";

    const dispatch = createEventDispatcher();

    let focused = false;
    const onFocus = () => (focused = true);
    const onBlur = () => (focused = false);

    const onModalOpen = async () => {
        const result = await ModalSystem.show<any>({
            component: LookupDialog,
            props: {
                title: label,
                icon,
                items: iitems,
                dictionaryFunc,
                dictionary: {
                    title: dictionary.title,
                    description: dictionary.description,
                    icon:dictionary.icon,
                },
            },
            parameters: { size: "medium", canClose: true },
        });

        if (result && dictionary) {
            selected = result;
            ivalue = result[dictionary.value];
            value = ivalue;
            display();
            onChange();
        }
    };

    const display = (): string => {

        if (dictionary && iitems && ivalue) {
            let i = iitems.find((i) => i[dictionary.value] == ivalue);
            iTitle = i[dictionary.title];
        }

        return ""
    };

    const onChange = () => {
        if (disabled) return;
        dispatch("change", { selected });
    };
</script>

<div class="dropdown-area" on:click={onModalOpen}>
    <label
        style="background: {bg};"
        class:focused
        class="dropdown-label"
        {disabled}
        for={name}>{label}</label
    >
    <div
        {id}
        {name}
        style="background: {bg}; width: {width};"
        class:focused
        class="dropdown"
        {disabled}
        on:focus={onFocus}
        on:blur={onBlur}
        tabindex="0"
    >
        <span class="value">{iTitle}</span>
        <CaretDown
            width={24}
            height={24}
            color={focused
                ? "var(--drop-active-color)"
                : "var(--drop-color)"}
        />
    </div>
</div>

<style>
    /*  
    --color-level-0: #1e1e1e;
    --color-level-1: #2c2c2c;
    --color-level-2: #393939;
    --color-level-3: #595959;
    --color-level-4: #666666;
    --color-level-5: #808080;
    --color-level-6: #b7b7b7;
    --color-level-7: #efefef; 
    */
    :root {
        --drop-border-color: var(--color-level-3, #595959);
        --drop-color: var(--color-level-7, #b7b7b7);
        --drop-active-color: var(--color-primary, #bb86fc);
        --drop-disabled-color: var(--color-level-5, #595959);
    }

    .dropdown-area {
        position: relative;
        height: 74px;
        display: flex;
        flex-grow: 1;
    }

    .dropdown-label {
        position: absolute;
        top: -5px;
        left: 10px;
        font-size: 12px;
        color: var(--drop-color);
        padding: 0 6px;
        z-index: 1;
    }

    .dropdown {
        border-radius: 4px;
        border: 2px solid var(--drop-color);
        height: 56px;
        width: 328px;
        font-size: 14px;
        background: transparent;
        color: var(--drop-color);
        padding: 16px;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .value {
        width: 100%;
    }

    .dropdown:active {
        border: 2px solid var(--drop-active-color);
    }

    .focused {
        color: var(--drop-active-color);
    }

    .dropdown[disabled="true"] {
        border: 2px solid var(--drop-disabled-color);
        color: var(--drop-disabled-color);
    }

    .dropdown-label[disabled="true"] {
        color: var(--drop-disabled-color);
    }
</style>
